import { render, staticRenderFns } from "./AssessmentInterviewQuestionSingleCol.vue?vue&type=template&id=38634322&scoped=true&"
import script from "./AssessmentInterviewQuestionSingleCol.vue?vue&type=script&lang=js&"
export * from "./AssessmentInterviewQuestionSingleCol.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentInterviewQuestionSingleCol.vue?vue&type=style&index=0&id=38634322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38634322",
  null
  
)

export default component.exports